import axios from "axios";

let rapsotecClient = axios.create({
  baseURL: import.meta.env.VITE_APP_RAPSOTEC_BACK_URL,
  headers: {},
});

const initRapsotecAuth = (accessToken) => {
  rapsotecClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

const initRapsoteUserLanguage = (lang) => {
  rapsotecClient.defaults.headers.common["Accept-Language"] = lang;
};

export default rapsotecClient;
export { rapsotecClient, initRapsotecAuth, initRapsoteUserLanguage };
